/* src/app/modules/institutions/institutions-events/event-form/event-form.component.scss */
.cw-submodule {
  margin-bottom: 20px;
}
.cw-submodule .cw-horizontalline {
  margin: 10px 0;
}
.cw-submodule ::ng-deep .cw-input-number-span {
  text-align: left;
}
.cw-input-hint {
  display: block;
  margin-left: 150px;
  margin-top: 3px;
  margin-bottom: 6px;
  font-size: 12px;
  color: #666;
  line-height: 1.3;
}
.cw-button-wrapper {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 16px;
}
/*# sourceMappingURL=event-form.component.css.map */
